module.exports = __webpack_public_path__ + "static/img/avatar.0cf9ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.png
// module id = 0gU3
// module chunks = 12